import React from "react";
import SnpBillComp from "./SnpBillComp";
import { SnpUIProvider } from "../../global/snpComponent/SnpUiProvider";
import SnpBillCompV2 from "./SnpBillCompV2";

export default function RestoBillingModuleV3() {
  return (
    <>
      <SnpUIProvider>
        <SnpBillCompV2 />
      </SnpUIProvider>
    </>
  );
  //UI Corner end
}
